var _line, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    x1: 15.26,
    y1: 15.297,
    x2: 15.26,
    y2: 15.297
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.313,20.265L16.42,15.37c-0.039-0.039-0.087-0.059-0.131-0.087c1.156-1.365,1.857-3.126,1.857-5.051 c0-4.318-3.513-7.831-7.831-7.831s-7.831,3.513-7.831,7.831c0,4.317,3.513,7.83,7.831,7.83c1.877,0,3.602-0.665,4.952-1.771 c0.03,0.047,0.051,0.098,0.092,0.139l4.894,4.895c0.146,0.146,0.338,0.22,0.53,0.22c0.191,0,0.384-0.073,0.53-0.22 C21.606,21.032,21.606,20.558,21.313,20.265z M10.315,16.562c-3.491,0-6.331-2.84-6.331-6.33c0-3.491,2.84-6.331,6.331-6.331 s6.331,2.84,6.331,6.331C16.646,13.723,13.806,16.562,10.315,16.562z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.bb733409cfc1ffd5078f15d10ca29ceb.svg";
export { ForwardRef as ReactComponent };